import { DetailedHTMLProps, FC, InputHTMLAttributes } from 'react'
import { Flex } from './styled'

const FlexWrapper: FC<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = ({ children, ...rest }) => <Flex {...rest}>{children}</Flex>

export default FlexWrapper
